import { ENTITY_LISTING_VIEW_TYPE } from '../../../../../constants/common'

export const VIEWINGS_VIEW_PARAM = 'view'

export const VIEWING_VIEW_TYPES = [
  ENTITY_LISTING_VIEW_TYPE.calendar,
  ENTITY_LISTING_VIEW_TYPE.calendarWithPreview,
  ENTITY_LISTING_VIEW_TYPE.table,
  ENTITY_LISTING_VIEW_TYPE.tableWithPreview,
]
